/**
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Policy api models
  Date: April 2020
**/

import { action, thunk } from 'easy-peasy';
import * as policyService from '../../services/policy';


const policyModel = {
  isPolicyLoaded: false,
  policyPK: '',
  policySK: '',
  setPolicyPK: action((state, payload) => {
    
    state.policyPK = payload;
  }),

  getPolicyContent: thunk(async (actions, payload) => {
    return await policyService.getPolicyContent(payload);
  }),

  getDataFromPreSignedURL: thunk(async (actions, payload) => {
    return await policyService.getDataFromPreSignedURL(payload);
  }),

  searchPolicies: thunk(async (actions, payload) => {
    return await policyService.searchPolicies(payload);
  }),

};


export default policyModel;
